<span class="name" [ngClass]="{'checked': checked}">{{criteria}}</span>


// WEBPACK FOOTER //
// ./src/app/reports/pcl-criteria-icon/pcl-criteria-icon.component.html